import { createSelector } from 'reselect';
import { RootState } from '../index';

const configReducerSelector = (state: RootState) => state.config;

export const config_loader = createSelector(configReducerSelector, (config) => config.loader);

export const config_getEnv = createSelector(configReducerSelector, (config) => config.env);
